import { render, staticRenderFns } from "./KoekList.vue?vue&type=template&id=8aae9b10&scoped=true&"
import script from "./KoekList.vue?vue&type=script&lang=js&"
export * from "./KoekList.vue?vue&type=script&lang=js&"
import style0 from "./KoekList.vue?vue&type=style&index=0&id=8aae9b10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aae9b10",
  null
  
)

export default component.exports